import React from 'react';
import { Link } from 'react-router-dom';
import Pagination from '../Pagination';
import Loading from '../Loading';
import Routes from './../../Shared/routes';
import NewsCategory from '../../Entities/NewsCategory';


interface IProps {
    pages: number;
    currentPage: number;
    onLoadMore: (page: number) => void;
    list: NewsCategory[];
    error: string;
    remove: (newsCategoryId: number) => void;
    addSource: () => void;
    isLoading: boolean;
}

export default class NewsCategoryList extends React.Component<IProps> {

    onPage = (page: number) => {
        this.props.onLoadMore(page);
    }

    onAddSource = () => {
        this.props.addSource();
    }

    renderItem = (item: NewsCategory) => {
        return (
            <tr>
                <td>{item.getId()}</td>
                <td>{item.getTitle()}</td>
                <td>
                    <div style={{backgroundColor: item.getColor(), width: 10, height: 10 }} />
                    {item.getColor()}
                </td>
                <td>
                    <Link to={`${Routes.NEWS_CATEGORY_EDIT}${item.getId()}`}>Редактировать</Link><br />
                    <a href="#" onClick={() => this.props.remove(item.getId())}>Удалить</a>
                </td>
            </tr>
        )
    }

    render() {
        const { isLoading, list } = this.props;
        if (isLoading) {
            return <Loading />;
        }
        else {
            return (
                <>

                    <div className="app-title">
                        <div>
                            <h1><i className="fa fa-th-list"></i> Категории новостей</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            <div className="tile">
                                <button
                                    onClick={this.onAddSource}
                                    className="btn btn-primary"
                                    type="submit">Добавить категорию</button>
                                <br />
                                <br />
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Название</th>
                                            <th>Цвет</th>
                                            <th>Действия</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list.map(this.renderItem)}
                                    </tbody>
                                </table>
                                <Pagination
                                    onPage={this.onPage}
                                    pages={this.props.pages}
                                    current={this.props.currentPage} />
                            </div>
                        </div>
                    </div>
                </>
            )
        }
    }
}